import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as selectors from '../../reducers';
import styles from './council-page.module.scss';
import CouncilMapContainer from '../../components/council-map-container';
import {
  setActiveCouncil,
  setComparedCouncil,
  setActivePage,
} from '../../actions/ui';
import { dataCategories } from '../../helpers/formatters';
import scrollToComponent from '../../helpers/scroll-to-component';
import DataCard from '../../components/data-card';
import DataCubeRow from '../../components/data-cube-row';

class CouncilPage extends Component {
  constructor() {
    super();
    this.cardElements = {};
    this.selectCouncil = this.selectCouncil.bind(this);
    this.selectComparedCouncil = this.selectComparedCouncil.bind(this);
    this.goToSearch = this.goToSearch.bind(this);
    this.goToCompare = this.goToCompare.bind(this);
    this.scrollTo = this.scrollTo.bind(this);
  }

  scrollTo(card) {
    const element = this.cardElements[card];
    scrollToComponent(element);
  }

  goToSearch() {
    const { setActivePage, setActiveCouncil, setComparedCouncil } = this.props;
    setActivePage('search');
    setActiveCouncil(null);
    setComparedCouncil(null);
  }

  goToCompare() {
    const { setActivePage } = this.props;
    setActivePage('compareSelect');
  }

  selectCouncil(councilId) {
    const { setActiveCouncil } = this.props;
    setActiveCouncil(councilId);
  }

  selectComparedCouncil(councilId) {
    const { setComparedCouncil } = this.props;
    setComparedCouncil(councilId);
  }

  comparisonWithNoDataCouncils() {
    const { activeCouncil, comparedCouncil } = this.props;
    return (
      activeCouncil &&
      activeCouncil.isBlank &&
      comparedCouncil &&
      comparedCouncil.isBlank
    );
  }

  renderDataCards() {
    if (this.comparisonWithNoDataCouncils()) return null;
    return dataCategories.map((card) => {
      return (
        <DataCard
          key={card.id}
          ref={(el) => (this.cardElements[card.id] = el)}
          id={card.id}
          color={card.color}
          label={card.label}
        />
      );
    });
  }

  renderMaps() {
    const { activeCouncil, comparedCouncil, comparing } = this.props;
    return (
      <div className={styles.mapsRow}>
        <CouncilMapContainer
          key={comparing ? 0 : 1}
          onCouncilSelect={this.selectCouncil}
          council={activeCouncil}
          comparing={comparing}
          comparisonId={comparing ? comparedCouncil.id : null}
        />
        {comparing ? (
          <CouncilMapContainer
            key={2}
            council={comparedCouncil}
            onCouncilSelect={this.selectComparedCouncil}
            comparing={comparing}
            isComparisonCouncil={true}
          />
        ) : null}
      </div>
    );
  }

  renderNoDataNotice() {
    const { activeCouncil } = this.props;
    return activeCouncil.isBlank ? (
      <div className={styles.noDataNotice}>
        <span className={styles.noDataNoticeHeading}>notice</span>
        <span>
          {activeCouncil.name === 'Bayside Council'
            ? "No audited financial statement data available. See Auditor-General's Local Government 2017 report for details."
            : "No data presented. A modified audit opinion was issued on the financial statements. See Auditor-General's Local Government 2017 report for details."}
        </span>
      </div>
    ) : null;
  }

  render() {
    const { activeCouncil, comparedCouncil } = this.props;
    return (
      <div className={styles.councilPage}>
        <div className={styles.buttonsRow}>
          <button
            type="button"
            className={styles.backLink}
            onClick={this.goToSearch}
          >
            <img
              className={styles.backLinkImage}
              src={`${process.env.PUBLIC_URL}/img/chevron-icon.svg`}
              alt="chevron icon"
            />
            back to search
          </button>
          <button
            className={styles.compareButton}
            onClick={() => this.goToCompare()}
          >
            compare with another council
          </button>
        </div>
        {this.renderMaps()}
        {this.renderNoDataNotice()}
        <DataCubeRow
          activeCouncil={activeCouncil}
          comparedCouncil={comparedCouncil}
          onCubeClick={this.scrollTo}
        />
        {this.renderDataCards()}
      </div>
    );
  }
}

const mapDispatchToProps = {
  setActiveCouncil,
  setComparedCouncil,
  setActivePage,
};

const mapStateToProps = (state) => ({
  activeCouncil: selectors.getActiveCouncil(state),
  comparedCouncil: selectors.getComparedCouncil(state),
  comparing: selectors.getComparedCouncil(state) !== null,
  councils: selectors.getCouncils(state),
});

CouncilPage.propTypes = {
  councils: PropTypes.arrayOf(PropTypes.object),
  setActiveCouncil: PropTypes.func,
  setComparedCouncil: PropTypes.func,
  activeCouncil: PropTypes.object.isRequired,
  comparedCouncil: PropTypes.object,
  setActivePage: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(CouncilPage);



// WEBPACK FOOTER //
// ./src/pages/council-page/council-page.js